/**
 *稿件编辑页面的选择渠道指令
 */
"use strict";
angular.module("selectChannelModule", []).
directive("selectChannel", ["$timeout", function($timeout) {
	return {
		restrict: "E",
		scope: {
			selectedChannel:"=selectedChannel",
			channels:"=channels",
			formObj:"=formObj",
			doctype:"@doctype"
		},
		templateUrl: "./main/submissionManage/personalLibrary/selectChannel/selectChannel_tpl.html",
		link: function(scope, $element, $attrs) {
			
		},
		controller: function($scope, $element,$q,httpService,editPictureService,modalDialog) {
			initStatus();
			initData();
			function initStatus() {
				$scope.status = {
					picSizeLimit:10000
				}
				$scope.isHasChannelId = '';
			}

			function initData() {
			    $scope.$on('channels', function(e, data) {
			        $scope.channels = data;
			    });
//			    $scope.$watch('channels', function(e, data) {
//			        
//			    },true);
				$scope.$watch("selectedChannel", function(newVal, oldVal) {
					if(!newVal) return;
					initCover();
				});
			}
			function getSelectChannel() {
				var channels = $scope.status.channels;
				for(var i = 0; i < channels.length; i++) {
					var _c = channels[i];
					if(_c.checked) {
						$scope.isHasChannelId = true
					}
				}
				return data;
			}
			function initCover() {
				var data = $scope.selectedChannel;
				var cs = $scope.channels;
				for(var j in data) {
					for(var i in cs) {
						if(data[j].pubChannelId == cs[i].id) {
							cs[i].checked = true;
							cs[i].coverType = data[j].coverType;
							var imgArr = JSON.parse(data[j].coverImg)
							if(data[j].coverType == 0) {
								cs[i].pic1 = imgArr[0];
							} else if(data[j].coverType == 1) {
								cs[i].pic1 = imgArr[0];
								cs[i].pic2 = imgArr[1];
								cs[i].pic3 = imgArr[2];
							}
						}
					}
				}
//				for(var i in cs) {
//					for(var j in data) {
//						if(data[j].pubChannelId == cs[i].id) {
//							cs[i].checked = true;
//							cs[i].coverType = data[j].coverType;
//							var imgArr = JSON.parse(data[j].coverImg)
//							if(data[i]&&data[i].coverType == 0) {
//								cs[i].pic1 = imgArr[0];
//							} else if(data[i]&&data[i].coverType == 1) {
//								cs[i].pic1 = imgArr[0];
//								cs[i].pic2 = imgArr[1];
//								cs[i].pic3 = imgArr[2];
//							}
//						}
//					}
//				}
			}
			/**
			 * [delete description] 删除对应渠道的封面图
			 * @return {[type]} [description]
			 */
			$scope.delete = function(id,val){
				var cs = $scope.channels;
				cs.forEach(function(item){
					if(item.id == id){
						switch(val){
						case 1:
							item.pic1 = null;
						    break;
						case 2:
							item.pic2 = null;
						    break;
						case 3:
							item.pic3 = null;
						    break;
						}
					}
				})
			}
			/**
			 * [uploadPic description] 上传渠道封面图片
			 * @return {[type]} [description]
			 */
			$scope.uploadPic = function($files, $file, $newFiles, item, attribute) {
				if(!$file) return;
				uploadPic($file).then(function(res) {
					var picsize = '';
					if($scope.doctype=='video'){ 
						picsize = $scope.channels[0].channelVideoSize; 
					}else if($scope.doctype=='atlas'){ 
						picsize = $scope.channels[0].channelPicSize;
					}
					else if($scope.doctype=='imageText'){
						picsize = $scope.channels[0].channelNewPicSize;
					}
					editPictureService.newCropperAppForImage(angular.globalConfig.pictureServer + res.url, picsize).then(function(data) {
						if(data.success == '上传成功') {
							item[attribute] = angular.globalConfig.pictureServer + data.imgSrc;
						} else {
							modalDialog.success("图片上传失败", "error", false, function() {});
						}
					})
				}).catch(function(error){
					modalDialog.alertType("", error.message, "warning", false);
				})
			};
			/**
			 * [uploadPic description] 上传图片的公共方法
			 * @return {[type]} [description]
			 */
			function uploadPic(file) {
				var defer = $q.defer();
				if(file.size > Number($scope.status.picSizeLimit) * 1024) {
					modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
					defer.reject();
				}
				var fd = new FormData();
				var name = file.name;
				fd.append("file", file);
				fd.append("name", name);
				$.ajax({
					url: '/mcnww/upload/image.do',
					type: 'POST',
					headers:{requestToken:sessionStorage.getItem('requestToken')},
					async: false,
					data: fd,
					processData: false,
					contentType: false,
					success: function(data) {
						if(data.success){
							defer.resolve(data);
						}else{
							defer.reject(data);
						}
					}
				});
				return defer.promise;
			}
		}
	}
}]);